import React, { useState, useEffect } from 'react';

import {
  message,
  Button,
  Modal,
  Collapse
} from 'antd';

import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  SettingOutlined,
  LockOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons';
import { default as PackageNew } from '../../supplier/home/packageNew';
import { Loadding } from '../../components';
import {
  getOrderPackageList,
  getOrderPackageNoList,
  syncOrderPackageNo,
  getOrderGoodsList,
  updateOrderDeliveriedStatus
} from '../../services/Order';
import './style';

export default React.forwardRef((props, ref) => {
  const {
    suppliers,
    order,
    orderId,
    reload
  } = props;

  const [packageNos, setPackageNos] = useState([]);
  const [packages, setPackages] = useState([]);
  const [goods, setGoods] = useState([]);

  useEffect(() => {
    //getOrderGoodsList(orderId).then(data=> setGoods(data));
    getOrderPackageNoList(orderId).then(data => setPackageNos(data));
    getOrderPackageList(orderId).then(data => setPackages(data));
  }, []);

  const parsePackages = (rows) => {
    const tempPallets = [];
    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      if (tempPallets.indexOf(row.pallet_id) < 0 && row.pallet_id > 0) {
        tempPallets.push(row.pallet_id);
      }
      const find = goods.find(x => x.goods_spec_id === row.goods_spec_id);
      if (find) {
        row.goods_id = find.goods_id;
        row.goods_spec_id = find.goods_spec_id;
        row.goods_name = find.goods_name;
        row.size = find.size;
        row.weight = find.weight;
        row.price = find.price;
        row.pcs_per_carton = find.pcs_per_carton;
        row.carton_count_per_pallet = find.carton_count_per_pallet;
      }
    }

    let temp = [];
    tempPallets.forEach(x => {
      const f = rows.filter(y => y.pallet_id === x);
      if (f.length > 0) {
        f[0].isPallet = 1;
        temp = temp.concat(f);
      }
    })
    //if (tempPallets.length > 0) temp.push({});
    const c = rows.filter(y => y.pallet_id === -1);
    if (c.length > 0) {
      c[0].isPallet = -1;
      temp = temp.concat(c);
    }
    temp.push({});
    temp.push({});
    return temp;
  }

  const onSyncPackageList = (e, no, rows) => {
    // If you don't want click extra trigger collapse, you can prevent this:
    e.stopPropagation();
    Modal.confirm({
      title: `确定同步当前装箱单吗?`,
      icon: <ExclamationCircleOutlined />,
      content: <strong>{no.no}</strong>,
      okText: 'Yes',
      centered: true,
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        const key = 'sync_package';
        message.loading({ content: '正在同步装箱单...', key });
        syncOrderPackageNo(orderId, no.id).then(() => {
          getOrderPackageNoList(orderId).then(data => setPackageNos(data));
          getOrderPackageList(orderId).then(data => setPackages(data));
          updateOrderDeliveriedStatus(orderId, no.supplier_id).then(data=> {
            
          })
          reload && reload();
          message.success({ content: `装箱单同步完成`, key, duration: 2 });
        });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const genExtra = (no, rows) => (
    [
      <Button
        onClick={(e) => onSyncPackageList(e, no, rows)}
        type="primary"
        size="small"
        icon={<EditOutlined />}>
        同步此箱单
        </Button>
    ]
  );

  return (
    <p style={{ padding: '1rem 1rem' }}>
      <Collapse>
        {
          packageNos.filter(x => x.ds === 0 && (x.status === 0 ||x.status === 2) ).map(no => {
            const rows = parsePackages(packages.filter(x => x.package_id === no.id)).map(y=> ({...y, cartonCount: y.count > 0 ? y.count / y.pcs_per_carton : undefined, pcsPerCarton:  y.pcs_per_carton}));
            return <Collapse.Panel header={order.po + '-' + no.no + (no.status === 2 ? '  [已退回]' :'')} key={no.id} extra={genExtra(no, rows)}>
              {
                <PackageNew
                  supplier={suppliers.find(y=>y.id ===no.supplier_id)}
                  mode="view"
                  packageId={no.id}
                  packageList={no}
                  rows={rows}
                  goods={goods}
                />
              }
            </Collapse.Panel>
          })
        }
      </Collapse>
    </p>
  );
});
